import { IRestrictions } from './interfaces.d'

const collaBoratorsActions = [
  {
    text: 'Recibirán un email para la confirmación digital.',
    tooltip: false,
  },
  {
    text: 'Firmarán los documentos a presentar en los bancos que requieren solicitud física.',
    tooltip: true,
  },
]

const administratorActions = [
  'Tendrán todos los permisos, como agregar nuevos colaboradores u operar.',
  'Les enviaremos una invitación para hacerlo.',
]

const restrictions: IRestrictions = {
  digital: {
    minAdministrators: 2,
    minLegalRepresentative: 1,
  },
  fisica: {
    minAdministrators: 2,
    minLegalRepresentative: 0,
  },
  mixta: {
    minAdministrators: 2,
    minLegalRepresentative: 1,
  },
}

const subscriptionInfo = {
  digital: {
    subscriptionType: 'digital',
    titleInfo:
      'A representantes legales o personas apoderadas y a quienes van a administrar la cuenta. Una vez completada la solicitud, podrás agregar otros roles.',
    subtitleInfo: `${restrictions.digital.minLegalRepresentative} representante legal o persona apoderada y ${restrictions.digital.minAdministrators} administradores`,
    extraInfo: 'La misma persona puede tener ambos roles. Por ejemplo, ser reprensentante legal y administrador.',
    collaBoratorsActions,
    administratorActions,
    restrictions: restrictions.digital,
  },
  fisica: {
    subscriptionType: 'fisica',
    titleInfo: 'Agregá administradores generales a la solicitud. Una vez completada, podrás agregar otros roles.',
    subtitleInfo: `${restrictions.fisica.minAdministrators} administradores`,
    administratorActions,
    restrictions: restrictions.fisica,
  },
  mixta: {
    subscriptionType: 'mixta',
    titleInfo:
      'A representantes legales o personas apoderadas y a quienes van a administrar la cuenta. Una vez completada la solicitud, podrás agregar otros roles.',
    subtitleInfo: `${restrictions.mixta.minLegalRepresentative} representante legal o persona apoderada y ${restrictions.mixta.minAdministrators} administradores`,
    extraInfo: 'La misma persona puede tener ambos roles. Por ejemplo, ser reprensentante legal y administrador.',
    collaBoratorsActions,
    administratorActions,
    restrictions: restrictions.mixta,
  },
}

export const ROLES_IDS = {
  administrator: 1,
  representative: 2,
}

export default subscriptionInfo
